module.exports = __webpack_public_path__ + "img/7.8bcd5f64.jpg";